import React from 'react';
import Select, { SelectProps } from 'antd/lib/select';
import { useQuery } from 'react-query';
import {
  getLandingPagesByCriteria,
  ParPageListResponse,
} from 'services/displayFramework';

export type ListOfLandingPagesProps = SelectProps<any> & {
  pagcode?: string;
  paglabel?: string;
};

const ListOfLandingPages = ({
  pagcode = '',
  paglabel = '',
  ...props
}: ListOfLandingPagesProps) => {
  const { data } = useQuery(
    ['getLandingPagesByCriteria', { pagcode, paglabel }],
    () =>
      getLandingPagesByCriteria({ pagcode, paglabel }).then((res) => res.list || [])
  );

  return (
    <Select {...props}>
      {data?.map((page: ParPageListResponse) => (
        <Select.Option value={page.pagurl} key={page.pagcode}>
          {page.paglabel}
        </Select.Option>
      ))}
    </Select>
  );
};

export default ListOfLandingPages;
